import { DriverEtaWithPreviousTripConnectionInput } from '@/models/gen/graphql';

import { GetDriverEtaWithPreviousTripDocument } from '@/api/queries';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';
import { queryInput } from '@/utils';

const [, runRefetchGetDriverEtaWithPreviousTrip] = graphApi(GetDriverEtaWithPreviousTripDocument);

export const getDriverEtaWithPreviousTrip = async (driverEtaId: string) => {
  const input: DriverEtaWithPreviousTripConnectionInput = {
    first: 1,
    after: null,
    query: [{ id: queryInput(driverEtaId) }],
  };
  const res = await runRefetchGetDriverEtaWithPreviousTrip({ input });

  return res?.searchDriverEtaWithPreviousTrip?.driverEtaWithPreviousTripConnection?.edges?.[0]?.node;
};

export const useGetDriverEtaWithPreviousTrip = createGraphApiHook(getDriverEtaWithPreviousTrip);

export default getDriverEtaWithPreviousTrip;
